"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var CalendarRecurringFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_CalendarRecurringFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 3V.5a.5.5 0 0 0-1 0V3a.5.5 0 0 0 1 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 1h3v2a1.5 1.5 0 0 0 3 0V1.009c.865.02 1.412.089 1.862.318a3 3 0 0 1 1.311 1.311c.27.53.317 1.197.325 2.362H.002C.01 3.835.057 3.169.327 2.638a3 3 0 0 1 1.311-1.311c.45-.23.997-.298 1.862-.318V3a1.5 1.5 0 1 0 3 0V1ZM0 11.2V6h16v4.023a1.292 1.292 0 0 0-.245-.023h-.449a5 5 0 0 0-7.892-1.749 1.388 1.388 0 0 0-.482.983 1.236 1.236 0 0 0-.75.523l-1.532 2.3A1.25 1.25 0 0 0 5.69 14h.449a5.019 5.019 0 0 0 1.583 2H4.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C0 13.72 0 12.88 0 11.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5.5a.5.5 0 0 0-1 0V3a.5.5 0 0 0 1 0V.5ZM8.833 9.67a3.001 3.001 0 0 1 4.72 1.33h-.863a.25.25 0 0 0-.208.389l1.533 2.299a.25.25 0 0 0 .416 0l1.533-2.3a.25.25 0 0 0-.208-.388h-1.16a4.002 4.002 0 0 0-6.52-2c-.207.183-.185.502.022.685.207.183.52.159.735-.015ZM6.849 13h-1.16a.25.25 0 0 1-.207-.389l1.533-2.299a.25.25 0 0 1 .416 0l1.533 2.3a.25.25 0 0 1-.208.388h-.863a3.001 3.001 0 0 0 4.72 1.33c.214-.174.528-.198.735-.015.207.183.228.502.021.684a4.002 4.002 0 0 1-6.52-2Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_CalendarRecurringFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = CalendarRecurringFill;
exports["default"] = _default;